import {
  SET_NAVIGATION_CONFIRM,
  REMOVE_NAVIGATION_CONFIRM,
} from '../actions/types';

const initialState = false;

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_NAVIGATION_CONFIRM:
      return true;
    case REMOVE_NAVIGATION_CONFIRM:
      return false;
    default:
      return state;
  }
}
